export const translations: Record<string, Record<string, string>> = {
  "en": {
    "hero.title": "Rare Watches & Fine Jewelry",
    "hero.subtitle": "Chosen with restraint. Presented with clarity.",
    "hero.cta": "Explore the Collection",
    "nav.shopWatches": "Shop Watches",
    "nav.shopJewelry": "Shop Jewelry",
    "nav.shopAccessories": "Shop Accessories",
    "nav.sellYourWatch": "Sell Your Watch",
    "nav.sellWatchJewelry": "Sell Your Watch/Jewelry",
    "nav.privateEmailList": "Private Email List",
    "nav.about": "About",
    "nav.sold": "Sold",
    "nav.faq": "FAQ",
    "nav.shipping": "Shipping",
    "nav.returns": "Returns",
    "nav.buyersProtection": "Buyers Protection",
    "nav.articles": "Articles",
    "nav.emailList": "E-Mail List",
    "nav.contactUs": "Contact Us",
    "category.watches": "Watches",
    "category.jewelry": "Jewelry",
    "category.comingSoon": "Coming Soon",
    "category.comingSoonDesc": "Our jewelry collection is being curated. Stay tuned.",
    "category.noProducts": "No products found",
    "category.discoverAll": "Discover All",
    "sell.title": "Sell Your Watch or Jewelry",
    "sell.subtitle": "We acquire exceptional pieces with discretion and clarity.",
    "sell.cta": "Begin Your Inquiry",
    "newsletter.title": "Join the Private List",
    "newsletter.subtitle": "Early access to new watches, jewelry, and selected releases.",
    "newsletter.placeholder": "Your email",
    "newsletter.placeholderFull": "Your email address",
    "newsletter.subscribe": "Subscribe",
    "newsletter.motaiTitle": "Join the MOTAI List",
    "newsletter.motaiSubtitle": "Be the first to know about new arrivals and curated insights.",
    "newsletter.value1": "Early access to new timepieces",
    "newsletter.value2": "Behind-the-scenes editorial",
    "newsletter.value3": "Collector knowledge & market notes",
    "footer.shop": "Shop",
    "footer.services": "Services",
    "footer.termsConditions": "Terms & Conditions",
    "footer.privacyPolicy": "Privacy Policy",
    "footer.refundPolicy": "Refund Policy",
    "footer.shippingReturns": "Shipping & Returns",
    "footer.cookiePolicy": "Cookie Policy",
    "footer.copyright": "All rights reserved.",
    "trust.whyChoose": "Why Choose MOTAI",
    "trust.expertAuth": "Expert Authentication",
    "trust.expertAuthDesc": "Every timepiece verified by certified horologists before listing.",
    "trust.personalGuidance": "Personal Guidance",
    "trust.personalGuidanceDesc": "If needed, we are available to help you navigate the collection with clarity and discretion.",
    "trust.maintained": "Professionally Maintained",
    "trust.maintainedDesc": "Each watch is carefully inspected and maintained over time to preserve its quality, function, and presentation.",
    "trust.questions": "Still have questions?",
    "trust.reachUs": "Reach us at",
    "trust.orVisit": "or visit our",
    "trust.expertAuthShort": "Every piece is verified before listing.",
    "trust.maintainedShort": "Carefully maintained to preserve quality and function.",
    "trust.viewSold": "View Sold Pieces",
    "trust.viewSoldDesc": "A selection of pieces no longer available.",
    "trust.exploreSold": "Explore Sold Archive",
    "archive.title": "The Archive",
    "archive.subtitle": "A curated selection of timepieces and companions, chosen with care.",
    "archive.filter": "Filter",
    "archive.sortBy": "Sort By",
    "archive.featured": "Featured",
    "archive.newest": "Newest",
    "archive.priceLowHigh": "Price: Low → High",
    "archive.priceHighLow": "Price: High → Low",
    "archive.noMatch": "No pieces match your current filters.",
    "archive.clearAll": "Clear all filters",
    "archive.brand": "Brand",
    "archive.clearAllBtn": "Clear All",
    "archive.apply": "Apply",
    "product.loading": "Loading...",
    "product.notFound": "Product not found",
    "product.preOwned": "Pre-Owned",
    "product.addToCart": "Add to Cart",
    "product.inStock": "In stock — ready to ship within 1–2 business days",
    "product.freeShipping": "Free Insured Shipping",
    "product.authenticity": "Authenticity Guaranteed",
    "product.returns14": "14-Day Returns",
    "product.personalSupport": "Personal Support",
    "product.productInfo": "Product Info",
    "product.brand": "Brand",
    "product.showLess": "Show Less",
    "product.readMore": "Read More",
    "product.shipping": "Shipping",
    "product.taxes": "Taxes",
    "product.inquiries": "Inquiries & Bank Wire",
    "product.pairsWellWith": "Pairs well with",
    "product.shippingDesc1": "Handled with care. Shipped with discretion.",
    "product.shippingDesc2": "We currently ship within the United States only.",
    "product.shippingDesc3": "All orders are carefully packed, fully insured, and sent with tracking. Orders are dispatched promptly after payment confirmation.",
    "product.shippingDesc4": "Estimated delivery time within the U.S.: 4–10 business days.",
    "product.shippingDesc5": "Each piece is shipped in discreet, protective packaging, with no unnecessary external branding.",
    "product.shippingDesc6": "A 14-day return window begins once the order is delivered.",
    "product.shippingDesc7": "For full details, please refer to our Shipping Policy and Frequently Asked Questions.",
    "product.taxesDesc1": "Orders are shipped within the United States only.",
    "product.taxesDesc2": "Applicable sales tax is calculated based on the destination state and will appear at checkout where required.",
    "product.taxesDesc3": "No customs duties apply to domestic U.S. orders.",
    "product.taxesDesc4": "For further information, please refer to our Frequently Asked Questions.",
    "product.inquiriesDesc1": "If you require further assistance, or prefer to complete your purchase by bank transfer, please contact us by email.",
    "product.inquiriesDesc2": "We will be glad to assist you personally.",
    "sold.title": "Sold",
    "sold.subtitle": "A selection of pieces no longer available.",
    "sold.noMatch": "No sold pieces match your current filters.",
    "reviews.title": "Client Experiences",
    "reviews.ratedOn": "Rated",
    "reviews.onGoogle": "on Google · 120+ reviews",
    "reviews.viewGoogle": "View Google Reviews",
    "related.relatedProducts": "Related Products",
    "related.recentlyViewed": "Recently Viewed",
    "companion.title": "Companion Collection",
    "companion.subtitle": "Refine the character of your vintage collection.",
    "companion.showAll": "Show All",
    "product.latest": "Latest",
    "emailList.title": "Join the Private List",
    "emailList.subtitle": "Early access to new watches, jewelry, and selected releases."
  },
  "de": {
    "hero.title": "Seltene Uhren & Erlesener Schmuck",
    "hero.subtitle": "Mit Bedacht gewählt. Mit Klarheit präsentiert.",
    "hero.cta": "Kollektion entdecken",
    "nav.shopWatches": "Uhren",
    "nav.shopJewelry": "Schmuck",
    "nav.shopAccessories": "Accessoires",
    "nav.sellYourWatch": "Uhr verkaufen",
    "nav.sellWatchJewelry": "Uhr/Schmuck verkaufen",
    "nav.privateEmailList": "Exklusive E-Mail-Liste",
    "nav.about": "Über uns",
    "nav.sold": "Verkauft",
    "nav.faq": "FAQ",
    "nav.shipping": "Versand",
    "nav.returns": "Retouren",
    "nav.buyersProtection": "Käuferschutz",
    "nav.articles": "Artikel",
    "nav.emailList": "E-Mail-Liste",
    "nav.contactUs": "Kontakt",
    "category.watches": "Uhren",
    "category.jewelry": "Schmuck",
    "category.comingSoon": "Demnächst",
    "category.comingSoonDesc": "Unsere Schmuckkollektion wird derzeit kuratiert. In Kürze mehr.",
    "category.noProducts": "Keine Produkte gefunden",
    "category.discoverAll": "Alle entdecken",
    "sell.title": "Verkaufen Sie Ihre Uhr oder Ihren Schmuck",
    "sell.subtitle": "Wir erwerben außergewöhnliche Stücke mit Diskretion und Transparenz.",
    "sell.cta": "Anfrage starten",
    "newsletter.title": "Teil der exklusiven Liste werden",
    "newsletter.subtitle": "Frühzeitiger Zugang zu neuen Uhren, Schmuck und ausgewählten Veröffentlichungen.",
    "newsletter.placeholder": "Ihre E-Mail",
    "newsletter.placeholderFull": "Ihre E-Mail-Adresse",
    "newsletter.subscribe": "Abonnieren",
    "newsletter.motaiTitle": "Werden Sie Teil der MOTAI-Liste",
    "newsletter.motaiSubtitle": "Erfahren Sie als Erster von Neuzugängen und kuratierten Einblicken.",
    "newsletter.value1": "Frühzeitiger Zugang zu neuen Zeitmessern",
    "newsletter.value2": "Exklusive Einblicke hinter die Kulissen",
    "newsletter.value3": "Sammlerwissen & Marktanalysen",
    "footer.shop": "Shop",
    "footer.services": "Service",
    "footer.termsConditions": "AGB",
    "footer.privacyPolicy": "Datenschutz",
    "footer.refundPolicy": "Widerrufsrecht",
    "footer.shippingReturns": "Versand & Rückgabe",
    "footer.cookiePolicy": "Cookie-Richtlinie",
    "footer.copyright": "Alle Rechte vorbehalten.",
    "trust.whyChoose": "Warum MOTAI",
    "trust.expertAuth": "Experten-Authentifizierung",
    "trust.expertAuthDesc": "Jeder Zeitmesser wird vor der Aufnahme von zertifizierten Uhrmachern geprüft.",
    "trust.personalGuidance": "Persönliche Beratung",
    "trust.personalGuidanceDesc": "Wir stehen Ihnen zur Seite, um Sie mit Klarheit und Diskretion durch unsere Kollektion zu führen.",
    "trust.maintained": "Professionell gewartet",
    "trust.maintainedDesc": "Jede Uhr wird sorgfältig geprüft und gewartet, um Qualität, Funktion und Ästhetik zu bewahren.",
    "trust.questions": "Haben Sie noch Fragen?",
    "trust.reachUs": "Kontaktieren Sie uns unter",
    "trust.orVisit": "oder besuchen Sie unsere",
    "trust.expertAuthShort": "Jedes Stück wird vor dem Verkauf verifiziert.",
    "trust.maintainedShort": "Sorgfältig gewartet, um Qualität und Funktion zu erhalten.",
    "trust.viewSold": "Verkaufte Stücke ansehen",
    "trust.viewSoldDesc": "Eine Auswahl bereits verkaufter Stücke.",
    "trust.exploreSold": "Verkaufsarchiv erkunden",
    "archive.title": "Das Archiv",
    "archive.subtitle": "Eine kuratierte Auswahl an Zeitmessern und Begleitern, mit Sorgfalt gewählt.",
    "archive.filter": "Filter",
    "archive.sortBy": "Sortieren nach",
    "archive.featured": "Empfohlen",
    "archive.newest": "Neuheiten",
    "archive.priceLowHigh": "Preis: Niedrig → Hoch",
    "archive.priceHighLow": "Preis: Hoch → Niedrig",
    "archive.noMatch": "Keine Stücke entsprechen Ihren aktuellen Filtern.",
    "archive.clearAll": "Alle Filter löschen",
    "archive.brand": "Marke",
    "archive.clearAllBtn": "Alle löschen",
    "archive.apply": "Anwenden",
    "product.loading": "Wird geladen...",
    "product.notFound": "Produkt nicht gefunden",
    "product.preOwned": "Aus Vorbesitz",
    "product.addToCart": "In den Warenkorb",
    "product.inStock": "Auf Lager — versandfertig in 1–2 Werktagen",
    "product.freeShipping": "Kostenloser, versicherter Versand",
    "product.authenticity": "Garantierte Echtheit",
    "product.returns14": "14 Tage Rückgaberecht",
    "product.personalSupport": "Persönliche Betreuung",
    "product.productInfo": "Produktinformationen",
    "product.brand": "Marke",
    "product.showLess": "Weniger anzeigen",
    "product.readMore": "Mehr lesen",
    "product.shipping": "Versand",
    "product.taxes": "Steuern",
    "product.inquiries": "Anfragen & Banküberweisung",
    "product.pairsWellWith": "Passend dazu",
    "product.shippingDesc1": "Mit größter Sorgfalt behandelt. Diskret versendet.",
    "product.shippingDesc2": "Wir versenden derzeit ausschließlich innerhalb der Vereinigten Staaten.",
    "product.shippingDesc3": "Alle Bestellungen werden sorgfältig verpackt, voll versichert und mit Sendungsverfolgung verschickt. Der Versand erfolgt umgehend nach Zahlungseingang.",
    "product.shippingDesc4": "Voraussichtliche Lieferzeit innerhalb der USA: 4–10 Werktage.",
    "product.shippingDesc5": "Jedes Stück wird in einer diskreten Schutzverpackung ohne unnötiges Branding versendet.",
    "product.shippingDesc6": "Ein 14-tägiges Rückgaberecht beginnt mit der Zustellung der Bestellung.",
    "product.shippingDesc7": "Weitere Details finden Sie in unseren Versandrichtlinien und FAQs.",
    "product.taxesDesc1": "Der Versand erfolgt ausschließlich innerhalb der Vereinigten Staaten.",
    "product.taxesDesc2": "Die anfallende Umsatzsteuer wird basierend auf dem Bestimmungsort berechnet und erscheint, sofern erforderlich, beim Checkout.",
    "product.taxesDesc3": "Für inländische US-Bestellungen fallen keine Zollgebühren an.",
    "product.taxesDesc4": "Weitere Informationen entnehmen Sie bitte unseren FAQ.",
    "product.inquiriesDesc1": "Wenn Sie weitere Unterstützung benötigen oder den Kauf per Banküberweisung abschließen möchten, kontaktieren Sie uns bitte per E-Mail.",
    "product.inquiriesDesc2": "Wir freuen uns, Sie persönlich zu beraten.",
    "sold.title": "Verkauft",
    "sold.subtitle": "Eine Auswahl an Stücken, die nicht mehr verfügbar sind.",
    "sold.noMatch": "Keine verkauften Stücke entsprechen Ihren Filtern.",
    "reviews.title": "Kundenerfahrungen",
    "reviews.ratedOn": "Bewertet",
    "reviews.onGoogle": "auf Google · 120+ Rezensionen",
    "reviews.viewGoogle": "Google-Rezensionen ansehen",
    "related.relatedProducts": "Ähnliche Produkte",
    "related.recentlyViewed": "Zuletzt angesehen",
    "companion.title": "Companion Kollektion",
    "companion.subtitle": "Verfeinern Sie den Charakter Ihrer Vintage-Sammlung.",
    "companion.showAll": "Alle anzeigen",
    "product.latest": "Aktuell",
    "emailList.title": "Teil der exklusiven Liste werden",
    "emailList.subtitle": "Frühzeitiger Zugang zu neuen Uhren, Schmuck und ausgewählten Veröffentlichungen."
  },
  "fr": {
    "hero.title": "Horlogerie Rare & Haute Joaillerie",
    "hero.subtitle": "Sélectionnés avec retenue. Présentés avec clarté.",
    "hero.cta": "Explorer la Collection",
    "nav.shopWatches": "Montres",
    "nav.shopJewelry": "Joaillerie",
    "nav.shopAccessories": "Accessoires",
    "nav.sellYourWatch": "Vendre votre Montre",
    "nav.sellWatchJewelry": "Vendre Montre/Bijou",
    "nav.privateEmailList": "Liste Privée",
    "nav.about": "À Propos",
    "nav.sold": "Vendu",
    "nav.faq": "FAQ",
    "nav.shipping": "Livraison",
    "nav.returns": "Retours",
    "nav.buyersProtection": "Protection Acheteurs",
    "nav.articles": "Articles",
    "nav.emailList": "Liste de Diffusion",
    "nav.contactUs": "Nous Contacter",
    "category.watches": "Montres",
    "category.jewelry": "Joaillerie",
    "category.comingSoon": "Bientôt Disponible",
    "category.comingSoonDesc": "Notre collection de joaillerie est en cours de sélection. Restez à l'écoute.",
    "category.noProducts": "Aucun produit trouvé",
    "category.discoverAll": "Tout Découvrir",
    "sell.title": "Vendre votre Montre ou Bijou",
    "sell.subtitle": "Nous acquérons des pièces exceptionnelles avec discrétion et clarté.",
    "sell.cta": "Commencer votre Demande",
    "newsletter.title": "Rejoindre la Liste Privée",
    "newsletter.subtitle": "Accès anticipé aux nouvelles montres, bijoux et éditions limitées.",
    "newsletter.placeholder": "Votre e-mail",
    "newsletter.placeholderFull": "Votre adresse e-mail",
    "newsletter.subscribe": "S'abonner",
    "newsletter.motaiTitle": "Rejoindre la Liste MOTAI",
    "newsletter.motaiSubtitle": "Soyez le premier informé des nouveautés et de nos analyses exclusives.",
    "newsletter.value1": "Accès anticipé aux nouveaux garde-temps",
    "newsletter.value2": "Contenu éditorial exclusif",
    "newsletter.value3": "Savoir du collectionneur & notes de marché",
    "footer.shop": "Boutique",
    "footer.services": "Services",
    "footer.termsConditions": "Conditions Générales",
    "footer.privacyPolicy": "Politique de Confidentialité",
    "footer.refundPolicy": "Politique de Remboursement",
    "footer.shippingReturns": "Livraison & Retours",
    "footer.cookiePolicy": "Politique de Cookies",
    "footer.copyright": "Tous droits réservés.",
    "trust.whyChoose": "Pourquoi Choisir MOTAI",
    "trust.expertAuth": "Authentification d'Experts",
    "trust.expertAuthDesc": "Chaque garde-temps est vérifié par des horlogers certifiés avant sa mise en vente.",
    "trust.personalGuidance": "Accompagnement Personnel",
    "trust.personalGuidanceDesc": "Si nécessaire, nous sommes à votre disposition pour vous orienter à travers la collection avec clarté et discrétion.",
    "trust.maintained": "Entretien Professionnel",
    "trust.maintainedDesc": "Chaque montre est soigneusement inspectée et entretenue pour préserver sa qualité, son fonctionnement et sa présentation.",
    "trust.questions": "Encore des questions ?",
    "trust.reachUs": "Contactez-nous sur",
    "trust.orVisit": "ou consultez notre",
    "trust.expertAuthShort": "Chaque pièce est vérifiée avant la mise en vente.",
    "trust.maintainedShort": "Soigneusement entretenue pour préserver qualité et fonctionnement.",
    "trust.viewSold": "Voir les Pièces Vendues",
    "trust.viewSoldDesc": "Une sélection de pièces qui ne sont plus disponibles.",
    "trust.exploreSold": "Explorer les Archives de Vente",
    "archive.title": "Les Archives",
    "archive.subtitle": "Une sélection soignée de garde-temps et d'accessoires, choisis avec attention.",
    "archive.filter": "Filtrer",
    "archive.sortBy": "Trier par",
    "archive.featured": "Sélection",
    "archive.newest": "Nouveautés",
    "archive.priceLowHigh": "Prix : Croissant → Décroissant",
    "archive.priceHighLow": "Prix : Décroissant → Croissant",
    "archive.noMatch": "Aucune pièce ne correspond à vos filtres actuels.",
    "archive.clearAll": "Effacer tous les filtres",
    "archive.brand": "Marque",
    "archive.clearAllBtn": "Tout Effacer",
    "archive.apply": "Appliquer",
    "product.loading": "Chargement...",
    "product.notFound": "Produit non trouvé",
    "product.preOwned": "Occasion",
    "product.addToCart": "Ajouter au Panier",
    "product.inStock": "En stock — prêt à être expédié sous 1 à 2 jours ouvrables",
    "product.freeShipping": "Livraison Assurée Gratuite",
    "product.authenticity": "Authenticité Garantie",
    "product.returns14": "Retours sous 14 jours",
    "product.personalSupport": "Assistance Personnalisée",
    "product.productInfo": "Informations Produit",
    "product.brand": "Marque",
    "product.showLess": "Voir moins",
    "product.readMore": "Lire la suite",
    "product.shipping": "Livraison",
    "product.taxes": "Taxes",
    "product.inquiries": "Demandes & Virement Bancaire",
    "product.pairsWellWith": "Se marie parfaitement avec",
    "product.shippingDesc1": "Manipulé avec soin. Expédié avec discrétion.",
    "product.shippingDesc2": "Nous livrons actuellement uniquement aux États-Unis.",
    "product.shippingDesc3": "Toutes les commandes sont soigneusement emballées, entièrement assurées et envoyées avec suivi. Les commandes sont expédiées rapidement après confirmation du paiement.",
    "product.shippingDesc4": "Délai de livraison estimé aux États-Unis : 4–10 jours ouvrables.",
    "product.shippingDesc5": "Chaque pièce est expédiée dans un emballage protecteur et discret, sans marquage extérieur superflu.",
    "product.shippingDesc6": "Un délai de retour de 14 jours commence à compter de la livraison de la commande.",
    "product.shippingDesc7": "Pour plus de détails, veuillez consulter notre Politique de Livraison et notre Foire Aux Questions.",
    "product.taxesDesc1": "Les commandes sont expédiées uniquement aux États-Unis.",
    "product.taxesDesc2": "La taxe de vente applicable est calculée en fonction de l'État de destination et apparaîtra lors du paiement si nécessaire.",
    "product.taxesDesc3": "Aucun droit de douane ne s'applique aux commandes domestiques aux États-Unis.",
    "product.taxesDesc4": "Pour plus d'informations, veuillez consulter notre Foire Aux Questions.",
    "product.inquiriesDesc1": "Si vous avez besoin d'une assistance supplémentaire ou si vous préférez finaliser votre achat par virement bancaire, veuillez nous contacter par e-mail.",
    "product.inquiriesDesc2": "Nous serons ravis de vous assister personnellement.",
    "sold.title": "Vendu",
    "sold.subtitle": "Une sélection de pièces qui ne sont plus disponibles.",
    "sold.noMatch": "Aucune pièce vendue ne correspond à vos filtres actuels.",
    "reviews.title": "Expériences Clients",
    "reviews.ratedOn": "Noté",
    "reviews.onGoogle": "sur Google · plus de 120 avis",
    "reviews.viewGoogle": "Voir les avis Google",
    "related.relatedProducts": "Produits Similaires",
    "related.recentlyViewed": "Consultés Récemment",
    "companion.title": "Collection Companion",
    "companion.subtitle": "Affinez le caractère de votre collection de pièces vintage.",
    "companion.showAll": "Tout Afficher",
    "product.latest": "Derniers Arrivages",
    "emailList.title": "Rejoindre la Liste Privée",
    "emailList.subtitle": "Accès anticipé aux nouvelles montres, bijoux et éditions limitées."
  },
  "it": {
    "hero.title": "Orologi Rari e Alta Gioielleria",
    "hero.subtitle": "Selezionati con rigore. Presentati con chiarezza.",
    "hero.cta": "Esplora la Collezione",
    "nav.shopWatches": "Orologi",
    "nav.shopJewelry": "Gioielleria",
    "nav.shopAccessories": "Accessori",
    "nav.sellYourWatch": "Vendi il tuo Orologio",
    "nav.sellWatchJewelry": "Vendi Orologio/Gioiello",
    "nav.privateEmailList": "Private Email List",
    "nav.about": "Chi Siamo",
    "nav.sold": "Venduti",
    "nav.faq": "FAQ",
    "nav.shipping": "Spedizione",
    "nav.returns": "Resi",
    "nav.buyersProtection": "Protezione Acquirenti",
    "nav.articles": "Articoli",
    "nav.emailList": "E-Mail List",
    "nav.contactUs": "Contattaci",
    "category.watches": "Orologi",
    "category.jewelry": "Gioielleria",
    "category.comingSoon": "Prossimamente",
    "category.comingSoonDesc": "La nostra collezione di gioielli è in fase di cura. Restate sintonizzati.",
    "category.noProducts": "Nessun prodotto trovato",
    "category.discoverAll": "Scopri Tutto",
    "sell.title": "Vendi il tuo Orologio o Gioiello",
    "sell.subtitle": "Acquisiamo pezzi eccezionali con discrezione e trasparenza.",
    "sell.cta": "Inizia la tua Richiesta",
    "newsletter.title": "Iscriviti alla Private List",
    "newsletter.subtitle": "Accesso anticipato a nuovi orologi, gioielli e uscite selezionate.",
    "newsletter.placeholder": "La tua email",
    "newsletter.placeholderFull": "Il tuo indirizzo email",
    "newsletter.subscribe": "Iscriviti",
    "newsletter.motaiTitle": "Iscriviti alla Lista MOTAI",
    "newsletter.motaiSubtitle": "Sii il primo a conoscere i nuovi arrivi e gli approfondimenti curati.",
    "newsletter.value1": "Accesso anticipato ai nuovi segnatempo",
    "newsletter.value2": "Editoriali dietro le quinte",
    "newsletter.value3": "Conoscenza per collezionisti e note di mercato",
    "footer.shop": "Negozio",
    "footer.services": "Servizi",
    "footer.termsConditions": "Termini e Condizioni",
    "footer.privacyPolicy": "Informativa sulla Privacy",
    "footer.refundPolicy": "Politica di Rimborso",
    "footer.shippingReturns": "Spedizioni e Resi",
    "footer.cookiePolicy": "Cookie Policy",
    "footer.copyright": "Tutti i diritti riservati.",
    "trust.whyChoose": "Perché Scegliere MOTAI",
    "trust.expertAuth": "Autenticazione Esperta",
    "trust.expertAuthDesc": "Ogni segnatempo è verificato da orologiai certificati prima di essere messo in vendita.",
    "trust.personalGuidance": "Guida Personale",
    "trust.personalGuidanceDesc": "Siamo a disposizione per aiutarvi a navigare la collezione con chiarezza e discrezione.",
    "trust.maintained": "Manutenzione Professionale",
    "trust.maintainedDesc": "Ogni orologio è accuratamente ispezionato e mantenuto nel tempo per preservarne qualità, funzione e presentazione.",
    "trust.questions": "Hai ancora domande?",
    "trust.reachUs": "Contattaci a",
    "trust.orVisit": "o visita le nostre",
    "trust.expertAuthShort": "Ogni pezzo è verificato prima della vendita.",
    "trust.maintainedShort": "Accuratamente mantenuto per preservare qualità e funzione.",
    "trust.viewSold": "Visualizza i Pezzi Venduti",
    "trust.viewSoldDesc": "Una selezione di pezzi non più disponibili.",
    "trust.exploreSold": "Esplora l'Archivio del Venduto",
    "archive.title": "L'Archivio",
    "archive.subtitle": "Una selezione curata di segnatempo e accessori, scelti con cura.",
    "archive.filter": "Filtra",
    "archive.sortBy": "Ordina per",
    "archive.featured": "In Evidenza",
    "archive.newest": "Ultimi Arrivi",
    "archive.priceLowHigh": "Prezzo: Crescente → Decrescente",
    "archive.priceHighLow": "Prezzo: Decrescente → Crescente",
    "archive.noMatch": "Nessun pezzo corrisponde ai filtri selezionati.",
    "archive.clearAll": "Cancella tutti i filtri",
    "archive.brand": "Marchio",
    "archive.clearAllBtn": "Cancella Tutto",
    "archive.apply": "Applica",
    "product.loading": "Caricamento...",
    "product.notFound": "Prodotto non trovato",
    "product.preOwned": "Pre-Owned",
    "product.addToCart": "Aggiungi al Carrello",
    "product.inStock": "In magazzino — pronto per la spedizione in 1–2 giorni lavorativi",
    "product.freeShipping": "Spedizione Assicurata Gratuita",
    "product.authenticity": "Autenticità Garantita",
    "product.returns14": "Reso entro 14 giorni",
    "product.personalSupport": "Supporto Personale",
    "product.productInfo": "Informazioni Prodotto",
    "product.brand": "Marchio",
    "product.showLess": "Mostra Meno",
    "product.readMore": "Leggi di Più",
    "product.shipping": "Spedizione",
    "product.taxes": "Imposte",
    "product.inquiries": "Richieste e Bonifico Bancario",
    "product.pairsWellWith": "Si abbina bene con",
    "product.shippingDesc1": "Gestito con cura. Spedito con discrezione.",
    "product.shippingDesc2": "Attualmente spediamo solo all'interno degli Stati Uniti.",
    "product.shippingDesc3": "Tutti gli ordini sono accuratamente imballati, completamente assicurati e tracciati. Gli ordini vengono spediti tempestivamente dopo la conferma del pagamento.",
    "product.shippingDesc4": "Tempo di consegna stimato negli USA: 4–10 giorni lavorativi.",
    "product.shippingDesc5": "Ogni pezzo è spedito in una confezione protettiva discreta, senza branding esterno superfluo.",
    "product.shippingDesc6": "La finestra di reso di 14 giorni inizia alla consegna dell'ordine.",
    "product.shippingDesc7": "Per i dettagli completi, consultare la nostra Politica di Spedizione e le Domande Frequenti.",
    "product.taxesDesc1": "Gli ordini vengono spediti esclusivamente all'interno degli Stati Uniti.",
    "product.taxesDesc2": "L'imposta sulle vendite applicabile è calcolata in base allo stato di destinazione e apparirà al checkout dove richiesto.",
    "product.taxesDesc3": "Non si applicano dazi doganali per gli ordini domestici negli Stati Uniti.",
    "product.taxesDesc4": "Per ulteriori informazioni, consultare le nostre Domande Frequenti.",
    "product.inquiriesDesc1": "Se necessitate di ulteriore assistenza o preferite completare l'acquisto tramite bonifico bancario, vi preghiamo di contattarci via email.",
    "product.inquiriesDesc2": "Saremo lieti di assistervi personalmente.",
    "sold.title": "Venduto",
    "sold.subtitle": "Una selezione di pezzi non più disponibili.",
    "sold.noMatch": "Nessun pezzo venduto corrisponde ai filtri attuali.",
    "reviews.title": "Esperienze dei Clienti",
    "reviews.ratedOn": "Valutato",
    "reviews.onGoogle": "su Google · oltre 120 recensioni",
    "reviews.viewGoogle": "Visualizza Recensioni Google",
    "related.relatedProducts": "Prodotti Correlati",
    "related.recentlyViewed": "Visti di Recente",
    "companion.title": "Collezione Companion",
    "companion.subtitle": "Affina il carattere della tua collezione vintage.",
    "companion.showAll": "Mostra Tutto",
    "product.latest": "Ultimi Modelli",
    "emailList.title": "Iscriviti alla Private List",
    "emailList.subtitle": "Accesso anticipato a nuovi orologi, gioielli e uscite selezionate."
  },
  "es": {
    "hero.title": "Relojes Excepcionales & Alta Joyería",
    "hero.subtitle": "Seleccionados con moderación. Presentados con claridad.",
    "hero.cta": "Explorar la Colección",
    "nav.shopWatches": "Relojes",
    "nav.shopJewelry": "Joyería",
    "nav.shopAccessories": "Accesorios",
    "nav.sellYourWatch": "Venda su Reloj",
    "nav.sellWatchJewelry": "Venda su Reloj/Joya",
    "nav.privateEmailList": "Lista Privada de Correo",
    "nav.about": "Acerca de",
    "nav.sold": "Vendido",
    "nav.faq": "Preguntas Frecuentes",
    "nav.shipping": "Envíos",
    "nav.returns": "Devoluciones",
    "nav.buyersProtection": "Protección al Comprador",
    "nav.articles": "Artículos",
    "nav.emailList": "Lista de Correo",
    "nav.contactUs": "Contacto",
    "category.watches": "Relojes",
    "category.jewelry": "Joyería",
    "category.comingSoon": "Próximamente",
    "category.comingSoonDesc": "Nuestra colección de joyería está siendo curada. Esté atento.",
    "category.noProducts": "No se encontraron productos",
    "category.discoverAll": "Descubrir Todo",
    "sell.title": "Venda su Reloj o Joya",
    "sell.subtitle": "Adquirimos piezas excepcionales con discreción y claridad.",
    "sell.cta": "Iniciar una Consulta",
    "newsletter.title": "Únase a la Lista Privada",
    "newsletter.subtitle": "Acceso anticipado a nuevos relojes, joyería y lanzamientos selectos.",
    "newsletter.placeholder": "Su correo",
    "newsletter.placeholderFull": "Su dirección de correo electrónico",
    "newsletter.subscribe": "Suscribirse",
    "newsletter.motaiTitle": "Únase a la Lista MOTAI",
    "newsletter.motaiSubtitle": "Sea el primero en conocer las novedades y nuestra selección curada.",
    "newsletter.value1": "Acceso anticipado a nuevas piezas",
    "newsletter.value2": "Contenido editorial exclusivo",
    "newsletter.value3": "Conocimiento para coleccionistas y notas del mercado",
    "footer.shop": "Tienda",
    "footer.services": "Servicios",
    "footer.termsConditions": "Términos y Condiciones",
    "footer.privacyPolicy": "Política de Privacidad",
    "footer.refundPolicy": "Política de Reembolso",
    "footer.shippingReturns": "Envíos y Devoluciones",
    "footer.cookiePolicy": "Política de Cookies",
    "footer.copyright": "Todos los derechos reservados.",
    "trust.whyChoose": "Por qué elegir MOTAI",
    "trust.expertAuth": "Autenticación Experta",
    "trust.expertAuthDesc": "Cada pieza es verificada por relojeros certificados antes de su publicación.",
    "trust.personalGuidance": "Asesoramiento Personal",
    "trust.personalGuidanceDesc": "Estamos a su disposición para ayudarle a explorar la colección con claridad y discreción.",
    "trust.maintained": "Mantenimiento Profesional",
    "trust.maintainedDesc": "Cada reloj es inspeccionado y mantenido meticulosamente para preservar su calidad, función y presentación.",
    "trust.questions": "¿Todavía tiene preguntas?",
    "trust.reachUs": "Contáctenos en",
    "trust.orVisit": "o visite nuestras",
    "trust.expertAuthShort": "Cada pieza es verificada antes de su publicación.",
    "trust.maintainedShort": "Mantenidos con esmero para preservar su calidad y función.",
    "trust.viewSold": "Ver Piezas Vendidas",
    "trust.viewSoldDesc": "Una selección de piezas que ya no están disponibles.",
    "trust.exploreSold": "Explorar el Archivo de Ventas",
    "archive.title": "El Archivo",
    "archive.subtitle": "Una selección curada de guardatiempos y complementos, elegidos con esmero.",
    "archive.filter": "Filtrar",
    "archive.sortBy": "Ordenar por",
    "archive.featured": "Destacado",
    "archive.newest": "Más reciente",
    "archive.priceLowHigh": "Precio: Menor → Mayor",
    "archive.priceHighLow": "Precio: Mayor → Menor",
    "archive.noMatch": "Ninguna pieza coincide con sus filtros actuales.",
    "archive.clearAll": "Limpiar todos los filtros",
    "archive.brand": "Marca",
    "archive.clearAllBtn": "Limpiar Todo",
    "archive.apply": "Aplicar",
    "product.loading": "Cargando...",
    "product.notFound": "Producto no encontrado",
    "product.preOwned": "Seminuevo",
    "product.addToCart": "Añadir al Carrito",
    "product.inStock": "En stock — listo para ser enviado en 1–2 días hábiles",
    "product.freeShipping": "Envío Asegurado Gratuito",
    "product.authenticity": "Autenticidad Garantizada",
    "product.returns14": "Devoluciones en 14 días",
    "product.personalSupport": "Atención Personalizada",
    "product.productInfo": "Información del Producto",
    "product.brand": "Marca",
    "product.showLess": "Ver menos",
    "product.readMore": "Leer más",
    "product.shipping": "Envío",
    "product.taxes": "Impuestos",
    "product.inquiries": "Consultas y Transferencia Bancaria",
    "product.pairsWellWith": "Combina bien con",
    "product.shippingDesc1": "Gestionado con esmero. Enviado con discreción.",
    "product.shippingDesc2": "Actualmente solo realizamos envíos dentro de los Estados Unidos.",
    "product.shippingDesc3": "Todos los pedidos se empaquetan cuidadosamente, se aseguran por su valor total y cuentan con seguimiento. Se despachan puntualmente tras la confirmación del pago.",
    "product.shippingDesc4": "Tiempo estimado de entrega en EE. UU.: 4–10 días hábiles.",
    "product.shippingDesc5": "Cada pieza se envía en un embalaje discreto y protector, sin branding externo innecesario.",
    "product.shippingDesc6": "El plazo de devolución de 14 días comienza tras la entrega del pedido.",
    "product.shippingDesc7": "Para más detalles, consulte nuestra Política de Envíos y las Preguntas Frecuentes.",
    "product.taxesDesc1": "Los pedidos se envían únicamente dentro de los Estados Unidos.",
    "product.taxesDesc2": "El impuesto sobre las ventas aplicable se calcula según el estado de destino y aparecerá en el proceso de pago cuando sea requerido.",
    "product.taxesDesc3": "No se aplican aranceles aduaneros para pedidos domésticos en EE. UU.",
    "product.taxesDesc4": "Para más información, consulte nuestras Preguntas Frecuentes.",
    "product.inquiriesDesc1": "Si necesita asistencia adicional o prefiere completar su compra mediante transferencia bancaria, contáctenos por correo electrónico.",
    "product.inquiriesDesc2": "Será un placer asistirle personalmente.",
    "sold.title": "Vendido",
    "sold.subtitle": "Una selección de piezas que ya no están disponibles.",
    "sold.noMatch": "Ninguna pieza vendida coincide con sus filtros actuales.",
    "reviews.title": "Experiencias de Clientes",
    "reviews.ratedOn": "Valorado",
    "reviews.onGoogle": "en Google · +120 reseñas",
    "reviews.viewGoogle": "Ver Reseñas en Google",
    "related.relatedProducts": "Productos Relacionados",
    "related.recentlyViewed": "Vistos Recientemente",
    "companion.title": "Colección Companion",
    "companion.subtitle": "Refine el carácter de su colección vintage.",
    "companion.showAll": "Mostrar Todo",
    "product.latest": "Lo último",
    "emailList.title": "Únase a la Lista Privada",
    "emailList.subtitle": "Acceso anticipado a nuevos relojes, joyería y lanzamientos selectos."
  },
  "ar": {
    "hero.title": "ساعات نادرة ومجوهرات فاخرة",
    "hero.subtitle": "انتُقيت بتأنٍّ. وقُدِّمت بوضوح.",
    "hero.cta": "استكشف المجموعة",
    "nav.shopWatches": "تسوق الساعات",
    "nav.shopJewelry": "تسوق المجوهرات",
    "nav.shopAccessories": "تسوق الإكسسوارات",
    "nav.sellYourWatch": "بِع ساعتك",
    "nav.sellWatchJewelry": "بِع ساعتك/مجوهراتك",
    "nav.privateEmailList": "القائمة البريدية الخاصة",
    "nav.about": "عنّا",
    "nav.sold": "القائمة المباعة",
    "nav.faq": "الأسئلة الشائعة",
    "nav.shipping": "الشحن",
    "nav.returns": "الاسترجاع",
    "nav.buyersProtection": "حماية المشتري",
    "nav.articles": "المقالات",
    "nav.emailList": "القائمة البريدية",
    "nav.contactUs": "اتصل بنا",
    "category.watches": "الساعات",
    "category.jewelry": "المجوهرات",
    "category.comingSoon": "قريباً",
    "category.comingSoonDesc": "مجموعة مجوهراتنا قيد التنسيق حالياً. ابقوا على اطلاع.",
    "category.noProducts": "لم يتم العثور على منتجات",
    "category.discoverAll": "اكتشف الكل",
    "sell.title": "بِع ساعتك أو مجوهراتك",
    "sell.subtitle": "نقتني القِطع الاستثنائية بكل سرية ووضوح.",
    "sell.cta": "ابدأ استفسارك",
    "newsletter.title": "انضم إلى القائمة الخاصة",
    "newsletter.subtitle": "وصول مبكر للساعات الجديدة والمجوهرات والإصدارات المختارة.",
    "newsletter.placeholder": "بريدك الإلكتروني",
    "newsletter.placeholderFull": "عنوان بريدك الإلكتروني",
    "newsletter.subscribe": "اشتراك",
    "newsletter.motaiTitle": "انضم إلى قائمة MOTAI",
    "newsletter.motaiSubtitle": "كن أول من يعلم عن الوصول الجديد والرؤى المتخصصة.",
    "newsletter.value1": "وصول مبكر للقطع الزمنية الجديدة",
    "newsletter.value2": "محتوى حصري من وراء الكواليس",
    "newsletter.value3": "ثقافة المقتنين وملاحظات السوق",
    "footer.shop": "المتجر",
    "footer.services": "الخدمات",
    "footer.termsConditions": "الشروط والأحكام",
    "footer.privacyPolicy": "سياسة الخصوصية",
    "footer.refundPolicy": "سياسة الاسترداد",
    "footer.shippingReturns": "الشحن والارجاع",
    "footer.cookiePolicy": "سياسة ملفات الارتباط",
    "footer.copyright": "جميع الحقوق محفوظة.",
    "trust.whyChoose": "لماذا تختار MOTAI",
    "trust.expertAuth": "توثيق الخبراء",
    "trust.expertAuthDesc": "يتم فحص كل قطعة زمنية من قبل خبراء ساعات معتمدين قبل عرضها.",
    "trust.personalGuidance": "إرشاد شخصي",
    "trust.personalGuidanceDesc": "إذا لزم الأمر، نحن متاحون لمساعدتك في تصفح المجموعة بوضوح وسرية.",
    "trust.maintained": "صيانة احترافية",
    "trust.maintainedDesc": "يتم فحص كل ساعة وصيانتها بعناية بمرور الوقت للحفاظ على جودتها ووظيفتها ومظهرها.",
    "trust.questions": "لا يزال لديك أسئلة؟",
    "trust.reachUs": "تواصل معنا عبر",
    "trust.orVisit": "أو قم بزيارة",
    "trust.expertAuthShort": "يتم التحقق من كل قطعة قبل إدراجها.",
    "trust.maintainedShort": "تُصان بعناية للحفاظ على الجودة والأداء.",
    "trust.viewSold": "عرض القطع المباعة",
    "trust.viewSoldDesc": "مجموعة من القطع التي لم تعد متوفرة.",
    "trust.exploreSold": "استكشف أرشيف المبيعات",
    "archive.title": "الأرشيف",
    "archive.subtitle": "مجموعة مختارة من الساعات والقطع الرفيقة، انتُقيت بعناية فائقة.",
    "archive.filter": "تصفية",
    "archive.sortBy": "ترتيب حسب",
    "archive.featured": "المميز",
    "archive.newest": "الأحدث",
    "archive.priceLowHigh": "السعر: من الأقل ← الأعلى",
    "archive.priceHighLow": "السعر: من الأعلى ← الأقل",
    "archive.noMatch": "لا توجد قطع تطابق فلاتر البحث الحالية.",
    "archive.clearAll": "مسح جميع الفلاتر",
    "archive.brand": "العلامة التجارية",
    "archive.clearAllBtn": "مسح الكل",
    "archive.apply": "تطبيق",
    "product.loading": "جارٍ التحميل...",
    "product.notFound": "المنتج غير موجود",
    "product.preOwned": "مستعمل فاخر",
    "product.addToCart": "إضافة إلى السلة",
    "product.inStock": "متوفر — جاهز للشحن خلال 1–2 أيام عمل",
    "product.freeShipping": "شحن مجاني مؤمن عليه",
    "product.authenticity": "الأصالة مضمونة",
    "product.returns14": "إرجاع خلال 14 يوماً",
    "product.personalSupport": "دعم شخصي",
    "product.productInfo": "معلومات المنتج",
    "product.brand": "العلامة التجارية",
    "product.showLess": "عرض أقل",
    "product.readMore": "اقرأ المزيد",
    "product.shipping": "الشحن",
    "product.taxes": "الضرائب",
    "product.inquiries": "الاستفسارات والتحويل البنكي",
    "product.pairsWellWith": "يتماشى بشكل رائع مع",
    "product.shippingDesc1": "يتم التعامل مع القطعة بعناية. وتُشحن بكل سرية.",
    "product.shippingDesc2": "نشحن حالياً داخل الولايات المتحدة فقط.",
    "product.shippingDesc3": "تُغلف جميع الطلبات بعناية، وتؤمن بالكامل، وتُرسل مع رقم تتبع. يتم إرسال الطلبات فور تأكيد الدفع.",
    "product.shippingDesc4": "الوقت المقدر للتوصيل داخل الولايات المتحدة: 4-10 أيام عمل.",
    "product.shippingDesc5": "تُشحن كل قطعة في غلاف واقٍ سري، دون أي علامات تجارية خارجية غير ضرورية.",
    "product.shippingDesc6": "تبدأ مهلة الإرجاع لمدة 14 يوماً بمجرد تسليم الطلب.",
    "product.shippingDesc7": "لمزيد من التفاصيل، يرجى الرجوع إلى سياسة الشحن والأسئلة الشائعة.",
    "product.taxesDesc1": "تُشحن الطلبات داخل الولايات المتحدة فقط.",
    "product.taxesDesc2": "تُحسب ضريبة المبيعات المعمول بها بناءً على الولاية الوجهة وتظهر عند الدفع حيثما لزم الأمر.",
    "product.taxesDesc3": "لا تنطبق أي رسوم جمركية على الطلبات المحلية داخل الولايات المتحدة.",
    "product.taxesDesc4": "لمزيد من المعلومات، يرجى الرجوع إلى الأسئلة الشائعة الخاصة بنا.",
    "product.inquiriesDesc1": "إذا كنت بحاجة إلى مزيد من المساعدة، أو تفضل إتمام عملية الشراء عبر تحويل بنكي، يرجى التواصل معنا عبر البريد الإلكتروني.",
    "product.inquiriesDesc2": "يسعدنا مساعدتك بشكل شخصي.",
    "sold.title": "مبيعات سابقة",
    "sold.subtitle": "مجموعة مختارة من القطع التي لم تعد متوفرة.",
    "sold.noMatch": "لا توجد قطع مباعة تطابق فلاتر البحث الحالية.",
    "reviews.title": "تجارب العملاء",
    "reviews.ratedOn": "مُقيم",
    "reviews.onGoogle": "على Google · أكثر من 120 تقييم",
    "reviews.viewGoogle": "عرض تقييمات Google",
    "related.relatedProducts": "منتجات ذات صلة",
    "related.recentlyViewed": "شوهد مؤخراً",
    "companion.title": "مجموعة المقتنيات المكملة",
    "companion.subtitle": "عزز طابع مجموعتك الكلاسيكية.",
    "companion.showAll": "عرض الكل",
    "product.latest": "الأحدث",
    "emailList.title": "انضم إلى القائمة الخاصة",
    "emailList.subtitle": "وصول مبكر للساعات الجديدة والمجوهرات والإصدارات المختارة."
  },
  "zh-TW": {
    "hero.title": "稀珍腕錶與高級珠寶",
    "hero.subtitle": "謹慎選品，明晰呈現。",
    "hero.cta": "探索系列",
    "nav.shopWatches": "選購腕錶",
    "nav.shopJewelry": "選購珠寶",
    "nav.shopAccessories": "選購配件",
    "nav.sellYourWatch": "出售您的腕錶",
    "nav.sellWatchJewelry": "出售您的腕錶/珠寶",
    "nav.privateEmailList": "私人通訊名單",
    "nav.about": "關於我們",
    "nav.sold": "已售作品",
    "nav.faq": "常見問題",
    "nav.shipping": "配送細則",
    "nav.returns": "退貨政策",
    "nav.buyersProtection": "買家保障",
    "nav.articles": "專欄文章",
    "nav.emailList": "通訊訂閱",
    "nav.contactUs": "聯繫我們",
    "category.watches": "腕錶",
    "category.jewelry": "珠寶",
    "category.comingSoon": "即將登場",
    "category.comingSoonDesc": "我們的珠寶系列正在精心籌備中，敬請期待。",
    "category.noProducts": "查無相關商品",
    "category.discoverAll": "探索全部",
    "sell.title": "出售您的腕錶或珠寶",
    "sell.subtitle": "我們以嚴謹與專業的高度熱忱，收購各類珍稀傑作。",
    "sell.cta": "開始諮詢",
    "newsletter.title": "加入私人名單",
    "newsletter.subtitle": "優先獲取新進腕錶、珠寶及精選發佈資訊。",
    "newsletter.placeholder": "您的電子郵件",
    "newsletter.placeholderFull": "您的電子郵件地址",
    "newsletter.subscribe": "立即訂閱",
    "newsletter.motaiTitle": "加入 MOTAI 名單",
    "newsletter.motaiSubtitle": "率先掌握新品到貨資訊與獨家鑑賞心得。",
    "newsletter.value1": "新品時計優先購買權",
    "newsletter.value2": "幕後特輯內容",
    "newsletter.value3": "藏家知識與市場動態",
    "footer.shop": "線上購物",
    "footer.services": "專屬服務",
    "footer.termsConditions": "條款與細則",
    "footer.privacyPolicy": "隱私政策",
    "footer.refundPolicy": "退款政策",
    "footer.shippingReturns": "配送與退貨",
    "footer.cookiePolicy": "Cookie 政策",
    "footer.copyright": "保留所有權利。",
    "trust.whyChoose": "為何選擇 MOTAI",
    "trust.expertAuth": "專家鑑定",
    "trust.expertAuthDesc": "每一枚時計在架上前，均經過專業鐘錶檢測師驗證。",
    "trust.personalGuidance": "專人導引",
    "trust.personalGuidanceDesc": "若有需要，我們隨時為您提供清晰且嚴謹的收藏諮詢服務。",
    "trust.maintained": "專業維修保養",
    "trust.maintainedDesc": "每枚腕錶都經過細心檢查與長期維護，以確保其品質、功能與呈現狀態之完好。",
    "trust.questions": "仍有疑問？",
    "trust.reachUs": "聯繫我們於",
    "trust.orVisit": "或瀏覽我們的",
    "trust.expertAuthShort": "每件作品上架前皆經過驗證。",
    "trust.maintainedShort": "精心維護，保留完美品質與功能。",
    "trust.viewSold": "查看已售作品",
    "trust.viewSoldDesc": "精選已售罄的經典作品。",
    "trust.exploreSold": "探索已售檔案庫",
    "archive.title": "作品檔案庫",
    "archive.subtitle": "精心挑選的時計與配件系列，為您呈獻卓越之選。",
    "archive.filter": "篩選",
    "archive.sortBy": "排序方式",
    "archive.featured": "精選作品",
    "archive.newest": "最新上架",
    "archive.priceLowHigh": "價格：由低 → 高",
    "archive.priceHighLow": "價格：由高 → 低",
    "archive.noMatch": "目前篩選條件下無匹配作品。",
    "archive.clearAll": "清除所有篩選",
    "archive.brand": "品牌",
    "archive.clearAllBtn": "全部清除",
    "archive.apply": "套用",
    "product.loading": "讀取中...",
    "product.notFound": "找不到該商品",
    "product.preOwned": "二手珍藏",
    "product.addToCart": "加入購物車",
    "product.inStock": "現貨 — 可於 1-2 個工作天內發貨",
    "product.freeShipping": "全額保險免運配送",
    "product.authenticity": "真品保證",
    "product.returns14": "14 天退貨期",
    "product.personalSupport": "專人支援服務",
    "product.productInfo": "商品資訊",
    "product.brand": "品牌",
    "product.showLess": "顯示較少",
    "product.readMore": "閱讀更多",
    "product.shipping": "配送詳情",
    "product.taxes": "稅務細則",
    "product.inquiries": "諮詢與銀行轉帳",
    "product.pairsWellWith": "完美搭配推薦",
    "product.shippingDesc1": "謹慎處理，低調配送。",
    "product.shippingDesc2": "我們目前的配送範圍僅限美國境內。",
    "product.shippingDesc3": "所有訂單均經過精心包裝、全額投保並提供追蹤編號。確認付款後將立即發貨。",
    "product.shippingDesc4": "美國境內預計運送時間：4-10 個工作天。",
    "product.shippingDesc5": "每件作品均採用簡約的防護包裝配送，外盒不含不必要的外部品牌標識。",
    "product.shippingDesc6": "訂單配達後即享 14 天退貨窗口期。",
    "product.shippingDesc7": "欲知詳情，請參閱我們的配送政策與常見問題。",
    "product.taxesDesc1": "訂單僅限配送至美國境內。",
    "product.taxesDesc2": "適用的銷售稅將根據目的地州別計算，並於結帳時依規定顯示。",
    "product.taxesDesc3": "國內美國訂單無需支付海關關稅。",
    "product.taxesDesc4": "如需進一步資訊，請參閱我們的常見問題。",
    "product.inquiriesDesc1": "如果您需要進一步協助，或希望透過銀行轉帳方式完成購買，請透過電子郵件與我們聯繫。",
    "product.inquiriesDesc2": "我們很榮幸為您提供專人服務。",
    "sold.title": "已售罄",
    "sold.subtitle": "精選已售出的經典傑作。",
    "sold.noMatch": "目前篩選條件下無已售作品。",
    "reviews.title": "客戶體驗",
    "reviews.ratedOn": "評分",
    "reviews.onGoogle": "於 Google · 120 多則評論",
    "reviews.viewGoogle": "查看 Google 評論",
    "related.relatedProducts": "相關推薦",
    "related.recentlyViewed": "最近瀏覽",
    "companion.title": "隨行系列",
    "companion.subtitle": "為您的古董收藏增添獨特品味。",
    "companion.showAll": "顯示全部",
    "product.latest": "最新款式",
    "emailList.title": "加入私人通訊名單",
    "emailList.subtitle": "優先獲取新進腕錶、珠寶及精選發佈資訊。"
  }
} as const;
